import request from '../request'

export const getActivityList = (data) => {
  return request({
    url: '/app/activityRecord/getRecordList',
    method: 'post',
    data
  })
}

export const getActivityStatistics = (data) => {
  return request({
    url: '/app/activityRecord/getStatistics',
    method: 'post',
    data
  })
}

export const submitActivitySign = (data) => {
  return request({
    url: '/app/activityRecord/sing',
    method: 'post',
    data
  })
}

export const submitActivitySignIn = (data) => {
  return request({
    url: '/app/activityRecord/getActivity/singUserOf',
    method: 'post',
    data
  })
}

export const getActivityDetail = (params) => {
  return request({
    url: '/app/activityRecord/getActivity/info',
    method: 'get',
    params
  })
}
